"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VendorRFPAwarded = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.VendorRFPAwarded = typebox_1.Type.Object({
    vendor_response_id: typebox_1.Type.String(),
    vendor_name: typebox_1.Type.String(),
    first_name: typebox_1.Type.String(),
    proposal_number: typebox_1.Type.String(),
    award_message: typebox_1.Type.String(),
});
//# sourceMappingURL=vendor-rfp-awarded.js.map